import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Region(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 228 228",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M182.4 185.82c0 12.592-30.624 22.8-68.4 22.8-37.776 0-68.4-10.208-68.4-22.8s30.624-22.8 68.4-22.8c37.776 0 68.4 10.208 68.4 22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M57 78.153c0 15.191 11.76 43.719 35.015 84.825 9.756 17.254 17.909 30.246 17.976 30.384.868 1.375 2.405 2.199 3.942 2.199 1.537 0 3.141-.824 3.943-2.199.067-.138 8.353-13.198 18.109-30.452C159.172 121.597 171 93.07 171 78.084c0-32.377-25.593-58.704-57.067-58.704C82.593 19.586 57 45.845 57 78.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M144.067 67.852a3.027 3.027 0 00-2.624-2.043l-17.232-1.37-7.457-16.506a3.02 3.02 0 00-5.508-.003l-7.457 16.51-17.232 1.369a3.025 3.025 0 00-1.871 5.178L97.42 83.401l-4.504 19.503a3.024 3.024 0 004.625 3.195L114 95.126l16.459 10.973a3.03 3.03 0 003.461-.073 3.025 3.025 0 001.124-3.27l-5.528-19.346 13.711-12.338a3.029 3.029 0 00.84-3.22z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Region);
export default ForwardRef;